import React from 'react'
import BaseComponent from './BaseComponent'
import { NavLink } from 'react-router-dom'

export default class extends BaseComponent {

  constructor(props) {
  	super(props)
  	this.state = { anim: "" }
  }

  componentDidMount() {
  	setTimeout(() => { this.setState({ anim: "anim" }) }, 400)
  }

  render() {
  	let nav
  	this.props.nav ? nav = "side-nav open" : nav = "side-nav"

    let navItems = this.props.data.nav.map((item, i) => {
      if (item.role !== undefined) {
        if (this.props.user.role === item.role) {
          return (
            <li key={ i }><NavLink to={ item.route } exact={ item.route === "/" ? true : false } onClick={ this.props.hideNav }><div className="img"><img src={ item.icon } alt=""/></div>{ item.name }</NavLink></li>
          )
        }
      } else {
        return (
          <li key={ i }><NavLink to={ item.route } exact={ item.route === "/" ? true : false } onClick={ this.props.hideNav }><div className="img"><img src={ item.icon } alt=""/></div>{ item.name }</NavLink></li>
        )
      }
    })

    return (
      <div className={ nav + " " + this.state.anim }>
	     	<div className="close" onClick={ this.props.hideNav }></div>
	    	<div className="top">
	    		<img className="side-logo" src="/assets/img/logo-white.png" alt=""/>
	    	</div>
        <nav>
          <ul className="nav-items">
            { navItems }
          </ul>
        </nav>
	    	<div className="tdy-logo"><a href="https://tdy.pl" target="_blank"><img src="/assets/img/logo.png" alt="Today. Logo"/></a></div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/SideNav.js